// extracted by mini-css-extract-plugin
export default {"grid_col_4":"IntroPage_grid_col_4__EqyEj","animation":"IntroPage_animation__xDBy5"};